function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) {
        return Array.from(iter);
    }
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import { Departments } from '@stereoagency/constants';
import sanityReference from '../fragments/sanityReference.js';
import profile from '../documents/profile.js';
var schema = defineObject('teamSectionMember', {
    profile: {
        type: 'reference',
        title: 'Profile',
        to: [
            {
                type: 'profile'
            }
        ]
    },
    role: {
        title: 'Role',
        type: 'string',
        options: {
            list: Object.values(Departments)
        }
    },
    subtitle: {
        title: 'Subtitle',
        type: 'string'
    }
}, [
    profile.schema.profile
]);
var validator = z.object({
    _type: z.literal('teamSectionMember'),
    profile: sanityReference.validator.optional(),
    role: z.enum([
        Departments.GROUP_LEADER
    ].concat(_to_consumable_array(Object.values(Departments)))).optional(),
    subtitle: z.string().optional()
});
schema.teamSectionMember;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=teamSectionMember.js.map